import { createContext, useContext, useState } from 'react';

const ImageCacheContext = createContext();

export function ImageCacheProvider({ children }) {
  const [imageCache, setImageCache] = useState({});

  const addToCache = (playerName, imageUrl) => {
    setImageCache(prev => ({
      ...prev,
      [playerName]: imageUrl
    }));
  };

  const getFromCache = (playerName) => {
    return imageCache[playerName];
  };

  return (
    <ImageCacheContext.Provider value={{ imageCache, addToCache, getFromCache }}>
      {children}
    </ImageCacheContext.Provider>
  );
}

export function useImageCache() {
  return useContext(ImageCacheContext);
}
